const options = [
	"Chief procurement officer",
	"Procurement manager",
	"Category manager",
	"Procurement analysts",
	"Finance stakeholder",
	"Procurement stakeholder",
  ];

  export default options.map(x => ({label: x, value: x}))